import React from "react";
import Container from "@material-ui/core/Container";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import MoreIcon from "@material-ui/icons/MoreVert";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  toolbar: {
    minHeight: 128,
    alignItems: "flex-start",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    justifyContent: "space-between",
  },
  title: {
    flexGrow: 1,
    alignSelf: "flex-end",
  },
  breadcrumb: {
    fontSize: "14px",
  },
}));

const AutoBreadcrumb = (props) => {
  const links = props.links;
  const classes = useStyles();

  return (
    <div className="mb-3">
      <Breadcrumbs
        className={classes.breadcrumb}
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {links.map((link) => (
          <Link key={link.name} color="textPrimary" href={link.to}>
            {link.name}
          </Link>
        ))}
      </Breadcrumbs>
    </div>
  );
};

const PostulacionContainer = (props) => {
  const classes = useStyles();
  const related = props.related;
  const noIntro = props.noIntro;

  return (
    <React.Fragment>
      <AppBar position="static" elevation={0}>
        <Container maxWidth="lg">
          <Toolbar className={classes.toolbar}>
            <img
              style={{ width: "100%", maxWidth: "228px" }}
              src="https://www.uchile.cl/.resources/portal-uchile/images/logo-universidad-de-chile.svg"
            />
            <div>
              <IconButton aria-label="search" color="inherit">
                <SearchIcon />
              </IconButton>
              <IconButton edge="end" color="inherit">
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </Container>
      </AppBar>

      <Container maxWidth="lg">
        <div className="py-3">
          <AutoBreadcrumb
            links={[
              { name: "Inicio", to: "https://www.uchile.cl/" },
              {
                name: "Presentación",
                to: "https://www.uchile.cl/presentacion",
              },
              { name: "Asuntos Académicos", to: "https://www.uchile.cl/vaa" },
              {
                name: "Concursos Académicos",
                to: "https://www.uchile.cl/concursoAcademico",
              },
            ]}
          />
          {noIntro ? null : (
            <Grid container justify="space-between" spacing={5}>
              <Grid item xs={true}>
                <h4 className="pb-3">Concursos para cargos académicos</h4>
                <p>
                  Como parte de un programa de fortalecimiento de su planta de
                  profesores, la Universidad de Chile invita a personas con
                  grado doctor (Ph.D.) a participar en concursos públicos
                  convocados para proveer cargos académicos de jornada completa
                  en las unidades que se indican.
                </p>
              </Grid>
              <Grid item>
                <Paper
                  className="p-3"
                  elevation={0}
                  style={{ background: "rgba(0, 0, 0, 0.03)" }}
                >
                  <strong>Enlaces relacionados</strong>
                  <ul className="p-1 m-0" style={{ listStyle: "none" }}>
                    {related.map((link) => (
                      <li key={link.name}>
                        <NavigateNextIcon fontSize="small" />{" "}
                        <Link href={link.to}>{link.name}</Link>
                      </li>
                    ))}
                  </ul>
                </Paper>
              </Grid>
            </Grid>
          )}

          {props.children}
        </div>
      </Container>

      <AppBar position="static" elevation={0}>
        <div style={{ height: "700px" }}></div>
      </AppBar>
    </React.Fragment>
  );
};

export default PostulacionContainer;
